import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { fadeInOutAnimation } from '../../../../util/animations/fade-in-out.animation';
@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.scss'],
  animations: [fadeInOutAnimation()],
})
/**
 * @deprecated
 * Consider using {@link TabsWithCounterComponent}
 */
export class TabsComponent implements OnChanges {

  @Input() tabNamesRaw: string[] = [];
  @Input() selectedIndexTab: number;
  @Input() isGrey = false;
  @Input() type: TabType; // leave undefined for default tabs
  @Input() divTabsClass = '';
  @Output() selectedTabEmitter: EventEmitter<string> = new EventEmitter<string>();
  tabNames: TabButton[] = [];
  tabStyleList: TabStyle = ['modal-button', 'tab-size'];


  ngOnChanges(changes: SimpleChanges): void {
    if (changes.tabNamesRaw || changes.selectedIndexTab) {
      this.tabNames = this.tabNamesRaw.map((tabName) => (
        new TabButton(tabName, '')));
      if (this.tabNames.length > 0) {
        this.tabNames[this.selectedIndexTab ?? 0 ].currentClass = 'main-button';
      }

    }
    if (changes.type) {
      if (this.type === 'table') {
        this.tabStyleList = ['table-tab', 'aligned-row-container'];
      }
      if (this.type === 'underlined') {
        this.tabStyleList = ['underlined-tab', 'centered-row-container'];
      }
    }
    if (changes.isGrey) {
      if (this.isGrey) {
        this.tabStyleList = ['grey-tab', 'centered-row-container'];
      }
    }

    if (changes.selectedIndexTab) {
      this.changeTab(this.selectedIndexTab);
    }
  }

  changeTab(index: number): void {
    this.tabNames.map((tabName) => tabName.currentClass = '');
    if (!this.tabNames[index]) {
      return;
    }
    this.tabNames[index].currentClass = 'main-button';
    this.selectedTabEmitter.emit(this.tabNames[index].name);
  }

}

export class TabButton {
  name: string;
  currentClass: string;

  constructor(name: string, currentClass: string) {
    this.name = name;
    this.currentClass = currentClass;
  }
}

type TabStyle = ['modal-button', 'tab-size'] | ['table-tab', 'aligned-row-container']
| ['grey-tab', 'centered-row-container'] | ['underlined-tab', 'centered-row-container'];
type TabType = 'table' | 'underlined';
